import type { DBSchema } from 'idb';
import type { JSONDocNode } from '@atlaskit/editor-json-transformer/types';
import type { StepJson } from '@atlaskit/editor-common/collab';

/**
 * Database name prefix for offline editor databases.
 */
export const OFFLINE_STEPS_DATABASE_NAME_PREFIX = 'editor:offline-steps-';

/**
 * IndexedDB object store name for metadata.
 */
export const OFFLINE_META_STORE_NAME = 'meta';

/**
 * IndexedDB object store name for steps.
 */
export const OFFLINE_STEPS_STORE_NAME = 'steps';

/**
 * Database version for offline editor steps databases.
 */
export const OFFLINE_STEPS_DATABASE_VERSION = 2;

/**
 * Backup data structure for version insertion failures.
 */
export interface VersionInsertionBackup {
	adfContent: string;
}

/**
 * Schema definition for the offline editor steps database.
 */
export interface StepsDBSchema extends DBSchema {
	steps: {
		key: number;
		value: {
			step: StepJson;
		};
	};
	meta: {
		key: number;
		value: {
			doc: JSONDocNode;
			version: number;
			lastUpdated?: number;
			versionInsertionBackup?: VersionInsertionBackup;
		};
	};
}
